const Error = ({message}) => {
    return (
        <div
            className="alert alert-danger d-flex align-items-start shadow-sm border-0 mb-3"
            role="alert"
            style={{
                borderRadius: "14px",
                background: "linear-gradient(135deg, #dc3545, #c82333)",
                padding: "10px 15px",
                width: "100%",
            }}
        >
            <div
                className="d-flex align-items-center justify-content-center me-2"
                style={{
                    width: "20px",
                    height: "20px",
                    minWidth: "15px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.15)",
                }}
            >
                <i
                    className="material-symbols-rounded text-white"
                    style={{ fontSize: "20px" }}
                >
                    error
                </i>
            </div>

            <div className="flex-grow-1">
                <div
                    className="text-white"
                    style={{
                        fontSize: "13px",
                        opacity: 0.95,
                        lineHeight: "20px",
                    }}
                >
                    {message}
                </div>
            </div>
        </div>
    );
}

export default Error;